<!-- LOADER GLOBAL -->
<div class="global-loader" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-content">
      <div class="spinner"></div>
      <h3 class="loader-title">AfroTech News</h3>
      <p class="loader-text">Chargement des dernières actualités...</p>
    </div>
  </div>
</div>

<!-- CONTENU PRINCIPAL -->
<div class="main-content" [class.content-loaded]="isContentReady">
  <!-- ACTUALITÉS TECH AFRICAINES -->
  <section class="actualites-section pt-5 mt-header bg-light">
    <div class="container">

      <!-- Header -->
      <div class="text-center mb-5">
        <h2 class="fw-bold mb-2">Actualités Tech africaines</h2>
        <p class="text-muted">
          Tendances, chiffres, idées et pépites venues du continent. <br>
          À lire, à partager, à faire rayonner.
        </p>
      </div>

      <!-- À la une -->
      <div class="row mb-5">
        <div class="col-12" *ngIf="featuredArticle">
          <a [routerLink]="['/news', featuredArticle.slug]" class="une-banner-link text-decoration-none text-white d-block">
            <div class="position-relative une-banner overflow-hidden rounded">

              <!-- Image optimisée -->
              <img 
                [src]="featuredArticle.image.data.attributes.url" 
                alt="À la une"
                class="img-fluid une-image"
              >

              <!-- Badge -->
              <span class="badge-a-la-une">À LA UNE</span>

              <!-- Overlay -->
              <div class="une-overlay text-white p-4">
                <h4 class="fw-semibold mb-2">{{ featuredArticle.title }}</h4>
                <span class="btn btn-warning text-white btn-sm">Lire</span>
              </div>

            </div>
          </a>
        </div>
      </div>

      <!-- Grille des articles -->
      <div class="row g-4 pb-3">

        <!-- Exemple de carte article -->
        <div class="col-md-4" *ngFor="let article of displayedArticles">
          <a [routerLink]="['/news', article.attributes.slug]" class="card-article zoom-card-link text-decoration-none text-dark">
            <div class="bg-white rounded shadow-sm p-3 h-100 d-flex flex-column justify-content-between">
              <div>
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span 
                    class="badge mb-2" 
                    [ngStyle]="{
                      'background-color': getCategory(article)?.bgColor,
                      'color': getCategory(article)?.textColor
                    }"
                  >
                    {{ getCategory(article)?.name || "" }}
                  </span>

                  <span *ngIf="article.attributes.country"
                        class="badge text-uppercase bg-light text-dark px-2 py-1">
                    {{ article.attributes.country }}
                  </span>
                </div>

                <p class="text-muted small">{{ article.attributes.publishedAt | date:'dd MMMM yyyy' | uppercase }}</p>
                <h5 class="fw-semibold mb-2 text-dark">{{ article.attributes.title }}</h5>
                <p class="text-muted small" *ngIf="article.attributes.description">{{ article.attributes.description }}</p>

                <div *ngIf="article.attributes.quote" class="bg-warning text-white p-3 rounded small fst-italic">
                  "{{ article.attributes.quote }}"
                  <div class="text-end mt-1 small">— {{ article.attributes.author }}</div>
                </div>
              </div>

              <!-- Image article optimisée -->
              <div *ngIf="article.attributes.image">
                <img 
                  [src]="article.attributes.image.data.attributes.url + '?f_auto&q_auto'" 
                  alt="illustration"
                  class="img-fluid rounded news-image"
                >
              </div>

              <div class="mt-2 text-end">
                <a href="#" class="read-more-link">
                  Lire 
                  <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 1 1 .708-.708l4 4a.498.498 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                  </svg>
                </a>
              </div>
            </div>
          </a>
        </div>

      </div>

      <!-- Aucun article -->
      <div class="alert alert-warning text-center" *ngIf="data?.length === 0">
        Aucun article trouvé pour ce tag.
      </div>

      <!-- Voir plus -->
      <div class="text-center mt-4 alert-no-data" *ngIf="data && data.length > 0 && displayedArticles.length < data.length">
        <button class="btn-load-more" (click)="loadMoreArticles()">
          Voir plus
        </button>
      </div>

    </div>
  </section>

  <app-support-our-channel></app-support-our-channel>
  <div class="pb-75"></div>
</div>